import axios from 'axios'
import { routingRoute, searchRoute } from './apiRoutes'
import polyline from '@mapbox/polyline'

export const getSearchResults = ({ setResults, lat, lng, text }) => {
	axios
		.get(searchRoute({ lat, lng, text }), {
			headers: {
				'Api-Key': 'service.S1wFpm3lTKvZqjPz3aLPYdgdE4AARRtKTZpimtDg',
			},
		})
		.then((res) => {
			setResults(res.data)
		})
}

export const getRoutes = ({
	originLat,
	originLng,
	destLat,
	destLng,
	setRoute,
}) => {
	axios
		.get(routingRoute({ destLat, destLng, originLat, originLng }), {
			headers: {
				'Api-Key': 'service.S1wFpm3lTKvZqjPz3aLPYdgdE4AARRtKTZpimtDg',
			},
		})
		.then((res) => {
			if (res.data.status === 'ERROR') {
				console.log('No Route Found')
			} else {
				const pols = []
				res.data?.routes[0]?.legs[0]?.steps.forEach((el) => {
					pols.push(polyline.decode(el.polyline))
				})
				setRoute(pols)
			}
		})
}
